import PropTypes from "prop-types";
import { connect } from "react-redux";

import actions from "@/actions";

const TopBarHightlightMode = ({ changeMode }) => {
    return (
        <div className="topBar">
            <div className="row">
                <div className="col-sm">
                    <p className="textTopbar">Highlight Column</p>
                </div>
                <div className="col-sm">
                    <div className="link" onClick={() => changeMode("view")}>
                        Cancel Highlight
                    </div>
                </div>
            </div>
        </div>
    );
};

TopBarHightlightMode.propTypes = {
    changeMode: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
    changeMode: actions.map.general.changeMode,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TopBarHightlightMode);
